"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zh_CN = _interopRequireDefault(require("rc-pagination/lib/locale/zh_CN"));

var _zh_CN2 = _interopRequireDefault(require("../date-picker/locale/zh_CN"));

var _zh_CN3 = _interopRequireDefault(require("../time-picker/locale/zh_CN"));

var _zh_CN4 = _interopRequireDefault(require("../calendar/locale/zh_CN"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  locale: 'zh-cn',
  Pagination: _zh_CN["default"],
  DatePicker: _zh_CN2["default"],
  TimePicker: _zh_CN3["default"],
  Calendar: _zh_CN4["default"],
  // locales for all comoponents
  global: {
    placeholder: '请选择'
  },
  Table: {
    filterTitle: '筛选',
    filterConfirm: '确定',
    filterReset: '重置',
    selectAll: '全选当页',
    selectInvert: '反选当页',
    sortTitle: '排序',
    expand: '展开行',
    collapse: '关闭行'
  },
  Modal: {
    okText: '确定',
    cancelText: '取消',
    justOkText: '知道了'
  },
  Popconfirm: {
    cancelText: '取消',
    okText: '确定'
  },
  Transfer: {
    searchPlaceholder: '请输入搜索内容',
    itemUnit: '项',
    itemsUnit: '项'
  },
  Upload: {
    uploading: '文件上传中',
    removeFile: '删除文件',
    uploadError: '上传错误',
    previewFile: '预览文件',
    downloadFile: '下载文件'
  },
  Empty: {
    description: '暂无数据'
  },
  Icon: {
    icon: '图标'
  },
  Text: {
    edit: '编辑',
    copy: '复制',
    copied: '复制成功',
    expand: '展开'
  },
  PageHeader: {
    back: '返回'
  }
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/locale/zh_CN.js
// module id = 888
// module chunks = 1